import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AccountService} from '../services/account.service';


@Component({
  selector: 'nzo-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  isLoading: boolean;
  validateForm: FormGroup;
  password: any;
  userName: any;

  constructor(private fb: FormBuilder,
              private router: Router,
              public http: HttpClient,
              private accountService: AccountService) {
  }

  // 登录
  submitForm(): void {
    this.isLoading = true;
    // tslint:disable-next-line:forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
    this.accountService.Login({
      loginName: this.userName,
      password: this.password
    }).subscribe((r: any) => {
      this.router.navigate(['layout']);
    });
  }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      userName: [null, [Validators.required]],
      password: [null, [Validators.required]],
      remember: [true]
    });
  }
}
